import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  tagsContainer: {
    display: 'flex',
    flexWrap: 'wrap',

    '& .MuiChip-root': {
      cursor: 'default',
    },
  },
  descriptionSection: {
    marginBottom: theme.spacing(3),
  },
  tagsSection: {
    marginBottom: theme.spacing(3),
  },
  descriptionText: {
    whiteSpace: 'pre-wrap',
  },
  valueWithIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
  statusIcon: {
    marginLeft: theme.spacing(0.5),
    fontSize: '1.2rem',
  },
  activeIcon: {
    color: theme.palette.success.main,
  },
  inactiveIcon: {
    color: theme.palette.grey[500],
  },
  criticalityLowIcon: {
    color: theme.palette.info.main,
  },
  criticalityMediumIcon: {
    color: theme.palette.warning.main,
  },
  criticalityHighIcon: {
    color: theme.palette.error.main,
  },
  stickyMenuContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  chips: {
    marginLeft: theme.spacing(1),
  },
  tooltipChipTruncated: {
    maxWidth: '100px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));
